import { render, staticRenderFns } from "./TermOfService.vue?vue&type=template&id=7081ef22&scoped=true&"
var script = {}
import style0 from "./TermOfService.vue?vue&type=style&index=0&id=7081ef22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7081ef22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
